module.exports = __webpack_public_path__ + "img/reject.af88363d.png";